export interface AvailabilityTooltipInput {
	status: string;
	isOverThreshold: boolean;
	isFullyReimbursed: boolean;
	hasPriceAgreement: boolean;
	thresholdPercent: number;
}

/**
 * Derives the availability tooltip text purely from the backend `status` and
 * `decisionDetails` booleans (isOverThreshold / isFullyReimbursed / hasPriceAgreement).
 * No share/PUHR1/DNC recomputation happens on the client - the backend already
 * applies the DDD -> ODTD -> packages fallback when computing `isOverThreshold`.
 *
 * Priority order matches the PM specification:
 * 1) share over threshold, 2) PUHR1 "U", 3) DNC "X"/"Y", 4) unavailable.
 *
 * @returns {string} the tooltip text describing why the availability status was assigned.
 */
export function getAvailabilityTooltip({
	status,
	isOverThreshold,
	isFullyReimbursed,
	hasPriceAgreement,
	thresholdPercent,
}: AvailabilityTooltipInput): string {
	if (status === 'unavailable') {
		return `LP je považován za nedostupný, pokud jeho podíl ve skupině ATC a RS nedosáhne alespoň ${thresholdPercent} % z celkového počtu, popř. pokud nebylo uzavřeno písemné ujednání o nejvyšší ceně výrobce nebo o úhradě.`;
	}
	if (isOverThreshold) {
		return `LP je považován za dostupný, pokud jeho podíl v kombinaci ATC a RS dosáhne alespoň ${thresholdPercent} % z celkového počtu.`;
	}
	if (isFullyReimbursed) {
		return 'LP je považován za dostupný, pokud pole PUHR1 ve SCAU obsahuje hodnotu "U".';
	}
	if (hasPriceAgreement) {
		return 'LP je považován za dostupný, pokud pole DNC ve SCAU obsahuje hodnotu "X" nebo "Y".';
	}
	// Defensive fallback: an `available` status should always satisfy one of the checks above.
	return `LP je považován za nedostupný, pokud jeho podíl ve skupině ATC a RS nedosáhne alespoň ${thresholdPercent} % z celkového počtu, popř. pokud nebylo uzavřeno písemné ujednání o nejvyšší ceně výrobce nebo o úhradě.`;
}
